import React from 'react'
import { ITimeline } from './types'

export const TimelineContext = React.createContext<ITimeline>(null)
export default TimelineContext
